export default "__VITE_PUBLIC_ASSET__7489cf12__"